export default "__VITE_ASSET__4152adce__"